import React from 'react'
import styled from 'styled-components'

import { MarginContainer } from './common'
import EmptySavedItems from './EmptySavedItems'
import SavedItemsListNew from './SavedItemsList'
import SavedItemsListOld from './SavedItemsListOld'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Group from 'components/utils/Group'
import config from 'constants/config'
import { BasicTrip } from 'tripPlanner/types/common'
import { TripItem } from 'tripPlanner/types/tripItem'

const MarginlessModalContent = styled.div`
  flex-grow: 1;
`

interface Props {
  status: 'error' | 'success' | 'loading'
  trips: Array<BasicTrip> | undefined
  items: Array<TripItem> | undefined
  filters: Array<App.TripPlannerSubFilterType>
}

function SavedItemsTab({ status, trips, items, filters }: Props) {
  const SavedItemsList = config.TRIP_PLANNER_ENABLE_NEW_DETAIL_CARDS
    ? SavedItemsListNew
    : SavedItemsListOld

  return (
    <MarginlessModalContent>
      <Group direction="vertical" gap={8}>
        {status === 'loading' && (
          <MarginContainer>
            <LoadingIndicator inline />
          </MarginContainer>
        )}
        {status === 'success' && items && items.length === 0 && (
          <MarginContainer>
            <EmptySavedItems />
          </MarginContainer>
        )}
        {status === 'success' && trips && items && items.length > 0 && (
          <SavedItemsList trips={trips} tripItems={items} filters={filters} />
        )}
      </Group>
    </MarginlessModalContent>
  )
}

export default SavedItemsTab
